<div class="dialog-wrapper" dir="rtl">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">حظر العميل</h2>
    <button class="close-btn" (click)="onClose()">&#x2715;</button>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <div class="form-group">
      <label class="form-label">سبب الحظر</label>
      <input
        type="text"
        class="form-input"
        [(ngModel)]="blockReason"
        name="blockReason"
        placeholder=""
      />
    </div>
  </div>

  <!-- Footer Buttons -->
  <div class="dialog-footer">
    <button class="btn btn-cancel" (click)="onClose()">إلغاء</button>
    <button class="btn btn-submit" (click)="onSubmit()">تسجيل</button>
  </div>
</div>
